module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Add Comparison"},"de":{"text":"Auswahl hinzufügen"},"fr":{"text":"Ajouter une comparaison"},"it":{"text":"Aggiungi Paragone"}}')
  delete Component.options._Ctor
}
